import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

function Header() {
	const [menuOpen, setMenuOpen] = useState(false);

	return (
		<header className="site-header">
			{/* Top bar */}
			<div className="header-topbar">
				<div className="container topbar-inner">
					<div className="topbar-left">
						<a href="tel:9163160696" className="topbar-link" aria-label="Call us">
							<svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
							(916) 316-0696
						</a>
						<a href="mailto:info@appexconnecthub.com" className="topbar-link" aria-label="Email us">
							<svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 4h16v16H4V4Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M4 4l8 8 8-8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
							info@appexconnecthub.com
						</a>
					</div>
					<div className="topbar-social">
						<a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Follow us on Facebook">
							<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
						</a>
						<a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Follow us on Instagram">
							<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
						</a>
						<a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Follow us on LinkedIn">
							<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
						</a>
					</div>
				</div>
			</div>
			{/* Main nav */}
			<div className="header-main">
				<div className="container row">
					<a href="#main" className="skip-link">Skip to content</a>
					<Link to="/" className="brand" aria-label="Apex Specialty Contracting">
						<svg width="36" height="36" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect width="72" height="72" rx="14" fill="#c0392b"/>
							<path d="M12 52 36 18 60 52H46L36 34 26 52H12Z" fill="white"/>
							<path d="M22 52h28v4H22z" fill="white" opacity="0.5"/>
						</svg>
						<div className="brand-text">
							<span className="brand-name">Apex Specialty</span>
							<span className="brand-sub">Contracting LLC</span>
						</div>
					</Link>
					<button
						className="mobile-menu-btn"
						aria-label={menuOpen ? 'Close menu' : 'Open menu'}
						aria-expanded={menuOpen}
						onClick={() => setMenuOpen((o) => !o)}
					>
						{menuOpen ? (
							<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
						) : (
							<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
						)}
					</button>
					<nav className={`nav${menuOpen ? ' nav-open' : ''}`} aria-label="Primary" onClick={() => setMenuOpen(false)}>
						<NavLink to="/services">Services</NavLink>
						<NavLink to="/industries">Service Areas</NavLink>
						<NavLink to="/case-studies">Projects</NavLink>
						<NavLink to="/faq">FAQ</NavLink>
						<NavLink to="/about">About</NavLink>
						<NavLink to="/contact" className="nav-cta">Get a Free Estimate</NavLink>
					</nav>
				</div>
			</div>
		</header>
	);
}

export default Header;


